module.exports = __webpack_public_path__ + "img/icon-package-fup-dark.7e69e66.svg";